import LocationText from './LocationText';

export default LocationText;
